const  IconFilter = () => {

    return (

    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <line x1="4" y1="9.5" x2="8" y2="9.5" stroke="#405363"/>
        <line x1="3" y1="6.5" x2="9" y2="6.5" stroke="#405363"/>
        <line x1="2" y1="3.5" x2="10" y2="3.5" stroke="#405363"/>
        <line y1="0.5" x2="12" y2="0.5" stroke="#405363"/>
        </svg>
    )

}

export default IconFilter;
